import { Box, Button, Card, CardActionArea, CircularProgress, Divider, Grid, TableCell, Typography, tableCellClasses, styled, TableRow, TableContainer, TableHead, Table, TableBody } from "@mui/material"
import React from "react"
import OrderDispatch from "./model"
import OrderState from "../../State/OrderState"

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

class Order extends React.PureComponent<{}>{
    componentDidMount(): void {
        let dispatcher: OrderDispatch = (this.props as any).dispatcher
        dispatcher.fetch()
    }
    render() {
        let state: OrderState = (this.props as any).state
        let dispatcher: OrderDispatch = (this.props as any).dispatcher

        let html: JSX.Element

        if (state.loading) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <CircularProgress />
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }}>
                    در حال دریافت اطلاعات
                </Typography>
            </Box>
        } else if (state.data && state.data.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    سفارشی یافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetch()
                }}>تلاش مجدد</Button>
            </Box>
        } else if (state.error) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات دریافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetch()
                }}>تلاش مجدد</Button>
            </Box>
        } else {

            html = <Box sx={{ width: '100%', height: '100%', flexDirection: 'column' }} display='flex'
                justifyContent="center"
                alignItems="center">

                <TableContainer sx={{ flexGrow: 1 }}>
                    <Table sx={{ width: '100%' }} aria-label="customized table" stickyHeader>
                        <TableHead>
                            <TableRow>

                                <StyledTableCell align="right">ردیف</StyledTableCell>
                                <StyledTableCell align="right">تاریخ</StyledTableCell>
                                <StyledTableCell align="right">وضعیت</StyledTableCell>
                                <StyledTableCell align="right">محصول</StyledTableCell>
                                <StyledTableCell align="right">هزینه</StyledTableCell>
                                <StyledTableCell align="right">توضیحات</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {state.data?.map((value, index, arr) => {
                                let key = `#-Order-${index}`
                                return <StyledTableRow
                                    key={key}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                    <StyledTableCell align="right">{index + 1}</StyledTableCell>
                                    <StyledTableCell align="right">{new Date(value.createAt).toLocaleDateString('fa-IR')}</StyledTableCell>
                                    <StyledTableCell align="right">{value.state === 1 ? 'در حال انجام' : value.state === 2 ? 'انجام شد' : 'انجام نشد'}</StyledTableCell>
                                    <StyledTableCell align="right">{value.payload}</StyledTableCell>
                                    <StyledTableCell align="right">{value.cost.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}ت</StyledTableCell>

                                    <StyledTableCell align="right">{value.description}</StyledTableCell>
                                </StyledTableRow>
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        }

        return (<Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ flexDirection: 'row' }} display="flex"
                justifyContent="start"
                alignItems="center">
                <Typography fontWeight='fontWeightBold' variant="h6" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                    تاریخچه سفارشات
                </Typography>
            </Box>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ mt: 1 }} />
            <Box sx={{ height: '100%', width: '100%', flexDirection: 'column', mt: 2 }} display="contents"
                justifyContent="center"
                alignItems="center">
                <Card variant="elevation" sx={{ height: '100%', borderRadius: '12px', borderColor: 'transparent', p: 2, mr: 1, ml: 1, mt: 1 }} >
                    <Box sx={{ flexDirection: 'column', height: '100%' }} display="flex">

                        {html}
                    </Box>
                </Card>
            </Box>
        </Box>)
    }
}

export default Order